const FormResources = {

    form_data:{
        name:       '',
        note:       '',
        subject:    'Housekeeping Survey',
        email_body: '',
        pass:       false,
    },

    form_format:[
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Pass/Fail:',
            model_name: 'pass',
            ref:        'pass_input',
            ref_alt:    'pass_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  500,
            disabled:   false,
            step:       '',
            name:       'Notes:',
            model_name: 'note',
            ref:        'note_input',
            ref_alt:    'note_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Subject:',
            model_name: 'subject',
            ref:        'subject_input',
            ref_alt:    'subject_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  500,
            disabled:   false,
            step:       '',
            name:       'Email body:',
            model_name: 'email_body',
            ref:        'email_body_input',
            ref_alt:    'email_body_input_alt',
            required:   true,
        },
       
    ],
    form_format_individual_response:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   true,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  500,
            disabled:   true,
            step:       '',
            name:       'Completed Date:',
            model_name: 'updated_at_formatted',
            ref:        'updated_at_formatted_input',
            ref_alt:    'updated_at_formatted_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  245,
            disabled:   true,
            step:       '',
            name:       'Email:',
            model_name: 'email',
            ref:        'email_input',
            ref_alt:    'email_input_alt',
            required:   false,
        },
    ]


}

export default FormResources;